/* eslint-disable camelcase */
import useTrans from "@/hooks/useTrans.js";
import OtpForm from "@/pages/dang-ky/components/OtpForm";
import { useLocalContext } from "@/setup/locale-provider";
import { Button, Group, PasswordInput, Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import dynamic from "next/dynamic";
import React from "react";

const ReCAPTCHA = dynamic(() => import("../../../common/ReCapcha.js"));

export default function ForgetPassForm({
  sendOtp,
  authOtp,
  resend,
  resetPassword,
  callback,
}) {
  const trans = useTrans();
  const { getLabel } = useLocalContext();
  const [step, setStep] = React.useState(1);
  const [isReCaptchaNeeded, setIsReCaptchaNeeded] = React.useState(false);

  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: (value) =>
        value.length > 0 ? null : trans?.forgotPassword.validate.blank,
    },
  });

  const handleSubmit = async () => {
    try {
      const rs_sendOtp = await sendOtp(form.values.email);
      if (rs_sendOtp.status) {
        setStep(2);
      } else {
        form.setErrors({
          email: trans?.forgotPassword.validate.send,
        });
      }
    } catch (error) {
      console.log(
        "Error ForgetPassForm handleSubmit => ",
        error.data?.message || error.message || error.error || error
      );
      form.setErrors({
        email: error.data?.message || error.message || error.error || error,
      });
    }
  };

  const renderByStep = () => {
    switch (step) {
      case 1:
        return (
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <TextInput
              withAsterisk
              label={trans?.forgotPassword.username}
              {...form.getInputProps("email")}
              placeholder={trans?.forgotPassword.placeholder.username}
              mb={5}
              onFocus={() => {
                setIsReCaptchaNeeded(true);
              }}
            />
            <Group position="center">
              <Button
                type="submit"
                mt="sm"
                fullWidth
                variant="outline"
                color="dark"
              >
                <Text weight="500" transform="uppercase">
                {trans?.forgotPassword.submit}
                </Text>
              </Button>
            </Group>
          </form>
        );
      case 2:
        return (
          <OtpForm
            resend={resend}
            authOtp={authOtp}
            callback={() => {
              setStep(3);
            }}
          />
        );
      case 3:
        return (
          <ResetPassForm resetPassword={resetPassword} callback={callback} />
        );
    }
  };

  return (
    <div>
      {isReCaptchaNeeded && <ReCAPTCHA />}
      {renderByStep()}
      {/* <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput
          withAsterisk
          label={getLabel(
            "Email hoặc số điện thoại (chúng tôi sẽ gửi cho bạn mã OTP để đặt lại mật khẩu)"
          )}
          {...form.getInputProps("email")}
          placeholder={getLabel("Nhập email hoặc số điện thoại của bạn")}
          mb={5}
        />
        <Group position="center">
          <Button type="submit" mt="sm" fullWidth>
            <Text weight={"500"} transform="uppercase">
              {getLabel("Gửi và xác nhận")}
            </Text>
          </Button>
        </Group>
      </form> */}
    </div>
  );
}

function ResetPassForm({ resetPassword, callback }) {
  const trans = useTrans();
  const { getLabel } = useLocalContext();

  const form = useForm({
    initialValues: {
      newPassword: "",
      reNewPassword: "",
    },
    validate: {
      newPassword: (value) =>
        value.length > 0
          ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*#?&]{6,}$/.test(value)
            ? null
            : getLabel(
                "Mật khẩu có ít nhất 6 ký tự và ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số"
              )
          : getLabel("Mật khẩu không được để trống"),
      reNewPassword: (value, values) =>
        value.length > 0
          ? value !== values.newPassword
            ? getLabel("Nhập lại mật khẩu không trùng khớp")
            : null
          : getLabel("Mật khẩu không được để trống"),
    },
  });

  const handleSubmit = async () => {
    try {
      const rs_resetPassword = await resetPassword(form.values);
      if (rs_resetPassword.status) {
        callback(rs_resetPassword);
      } else {
        form.setErrors({ newPassword: rs_resetPassword.message });
      }
    } catch (error) {
      console.log(
        "Error ResetPassForm handleSubmit => ",
        error.data?.message || error.message || error.error || error
      );
      form.setErrors({
        newPassword:
          error.data?.message || error.message || error.error || error,
      });
    }
  };

  return (
    <div>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <PasswordInput
          withAsterisk
          label={trans?.resetPassword.newPassword}
          {...form.getInputProps("newPassword")}
          placeholder={trans?.resetPassword.placeholder}
          mb={5}
        />
        <PasswordInput
          withAsterisk
          label={trans?.resetPassword.reNewPassword}
          {...form.getInputProps("reNewPassword")}
          placeholder={trans?.resetPassword.placeholder}
          mb={5}
        />

        <Group position="center">
          <Button
            type="submit"
            mt="sm"
            fullWidth
            variant="outline"
            color="dark"
          >
            <Text weight="500" transform="uppercase">
            {trans?.resetPassword.submit}
            </Text>
          </Button>
        </Group>
      </form>
    </div>
  );
}
